import { render, staticRenderFns } from "./OFileUpload.vue?vue&type=template&id=67f8a127&scoped=true&"
import script from "./OFileUpload.vue?vue&type=script&lang=js&"
export * from "./OFileUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f8a127",
  null
  
)

export default component.exports